module.exports = __webpack_public_path__ + "img/receipt16.cc5be70d.png";